import {
  Col,
  Layout,
  Row,
  Typography,
  Card,
  Menu,
  Divider,
  Dropdown,
  Avatar,
  Button,
  Space,
  Image,
  Modal,
  Rate,
  Input,
  Drawer,
  message,
  Upload,
} from "antd";
// import Dragger from '../pages/Dragger/Dragger';
import React, { useEffect, useState } from "react";
import logono1 from "../../src/Image/logoFmr.png";
import icon_logo from "../../src/Image/icon_logo.png";
import logofmrgg from "../../src/Image/logoFmr2.png";
import R from "@routers/R";
import { Redirect, useHistory, useRouteMatch } from "react-router-dom";
import { useLocation } from "react-router-dom";
import type { UploadProps } from "antd";
import { Cookies, useCookies } from "react-cookie";
import HomeStatusAgent from "../pages/InsuranceComponent/HomeStatusAgent";
import {
  CK_SHARED_TOKEN,
  CK_ACCESS_TOKEN,
  CK_ACCESS_DATA_ROLE,
  CK_TYPE,
} from "@constant/constant";
import {
  UserOutlined,
  LogoutOutlined,
  SafetyCertificateOutlined,
  FileProtectOutlined,
  LockOutlined,
  FileTextOutlined,
  AppstoreOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  FormOutlined,
  FileDoneOutlined,
  FieldTimeOutlined,
  SyncOutlined,
  WarningOutlined,
  MenuOutlined,
  StarOutlined,
  InboxOutlined,
  CheckCircleTwoTone,
} from "@ant-design/icons";
import { APIEndpointWeb, webapi } from "@client/web";
import ModalPolicy from "@pages/AllModal/ModalPolicy/ModalPolicy";
import NewPasswordLogin from "@pages/AllSetting/NewPasswordLogin";
import ModalTermsOfUse from "@pages/AllModal/ModalCheckEkyc/ModalTermsOfUse/ModalTermsOfUse";
import HomeWebStatusAgent from "@pages/InsuranceComponent/HomeWebStatusAgent";
const { Text } = Typography;
const { Header, Sider, Content } = Layout;
export interface userDisplay {
  insurer: string;
  name: string;
  ref_code: string;
  account_type: string;
}
export interface ChildProps {
  resUserDisplayLogo?: any;
}
const { Dragger } = Upload;
// const desc = ["terrible", "bad", "normal", "good", "wonderful"];

const desc = ["แย่มาก", "ไม่ดี", "ปกติ", "ดี", "ยอดเยี่ยม"];
const InsuranceLayout: React.FC = (props): JSX.Element => {
  const [files, setFiles] = useState([]);
  const [goToPath, setGoToPath] = useState("");
  const history = useHistory();
  let location = useLocation();
  const route = useRouteMatch();
  const [resUserDisplay, setResUserDisplay] = useState<userDisplay>();
  const [resUserDisplayLogo, setResUserDisplayLogo] = useState<any>();
  const [WindowResize, setWindowResize] = useState(Number);
  const getCookies = new Cookies();
  const [isModalTermsAndConditions, setIsModalTermsAndConditions] = useState(
    false
  );
  const [isModalOpenPolicy, setIsModalOpenPolicy] = useState(false);
  const [showModalResetPassword, setShowModalResetPassword] = useState(false);
  const [showModalshowModalWarning, setShowModalshowModalWarning] = useState(
    false
  );
  const [showModalshowModalRate, setShowModalshowModalRate] = useState(false);
  const [valRatingscore1, setValRatingscore1] = useState<any>("");
  const [valRatingscore2, setValRatingscore2] = useState<any>("");
  const [valRatingscore3, setValRatingscore3] = useState<any>("");
  const [valRatingscore4, setValRatingscore4] = useState<any>("");
  const [valRatingComment, setValRatingComment] = useState<any>("");
  const [valScoreDashboard, setValScoreDashboard] = useState<any>("");
  const [valCommentDashboard, setValCommentDashboard] = useState<any>("");
  const [ticketdDescription, setTicketdDescription] = useState<any>("");
  const [collapsed, setCollapsed] = useState(false);
  const [defaultSelectedKeys, setdefaultSelectedKeys] = useState(["1"]);
  const [ticketImage, setTicketImage] = useState<any>([]);
  // const [hightOpenTop, setHightOpenTop] = useState<any>("");
  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
    CK_TYPE,
  ]);
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const [openTop, setOpenTop] = useState(false);
  const showDrawerTop = () => {
    setOpenTop(true);
  };
  const [openRight, setOpenRight] = useState(false);

  const showDrawerRight = () => {
    setOpenRight(true);
  };
  // const handleFileUpload = (file: File) => {
  //   setUploadedFile(file);
  //   // Do something with the uploaded file
  // };
  const onClose = () => {
    setOpen(false);
  };
  const onCloseTop = () => {
    // setHightOpenTop(false)
    setOpenTop(false);
  };
  const onCloseRight = () => {
    setOpenRight(false);
  };
  const handleGoToPath = (path: string): void => {
    setGoToPath(path);
  };
  const { children } = props;
  useEffect(() => {
    checkCookie();
  }, [route, cookies.shared_token]);

  const shared_token = getCookies.get("shared_token");
  useEffect(() => {}, [shared_token]);
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, [WindowResize]);

  useEffect(() => {
    if (location.pathname === "/dashboard-insurance") {
      setdefaultSelectedKeys(["1"]);
    } else if (location.pathname === "/send-request") {
      setdefaultSelectedKeys(["2"]);
    } else if (location.pathname === "/execution-status") {
      setdefaultSelectedKeys(["3"]);
    } else if (location.pathname === "/confirm-success") {
      setdefaultSelectedKeys(["4"]);
    } else if (location.pathname === "/manage-user") {
      setdefaultSelectedKeys(["5"]);
    }
    // setdefaultSelectedKeys()
  }, []);

  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };
  const showModal1 = () => {
    setIsModalTermsAndConditions(true);
  };
  const handleOk1 = () => {
    setIsModalTermsAndConditions(false);
  };

  const handleCancel1 = () => {
    setIsModalTermsAndConditions(false);
  };
  const showModal2 = () => {
    setIsModalOpenPolicy(true);
  };

  const handleOk2 = () => {
    setIsModalOpenPolicy(false);
  };

  const handleCancel2 = () => {
    setIsModalOpenPolicy(false);
  };
  const showModal3 = () => {
    setShowModalResetPassword(true);
  };

  const handleOk3 = () => {
    setShowModalResetPassword(false);
  };

  const handleCancel3 = () => {
    setShowModalResetPassword(false);
  };
  const showModalWarning = () => {
    setShowModalshowModalWarning(true);
  };
  const handleOkshowModalWarning = () => {
    setShowModalshowModalWarning(false);
  };

  const handleCancelWarning = () => {
    setShowModalshowModalWarning(false);
  };
  const showModalRate = () => {
    setShowModalshowModalRate(true);
  };
  const handleOkshowModalRate = () => {
    setShowModalshowModalRate(false);
  };

  const handleCancelRate = () => {
    setShowModalshowModalRate(false);
  };

  const checkCookie = () => {
    // var type = getCookies.get("type");
    webapi
      .get(`${APIEndpointWeb.checkCookie}`, {
        withCredentials: true,
      })
      .then(() => {
        getuserdisplay();
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === 401) {
          history.push("/login");
        }
      });
  };
  const getuserdisplay = async () => {
    try {
      const { data } = await webapi.get(`${APIEndpointWeb.GetUserDisplay}`, {
        // headers: { Authorization: `Bearer ${cookies.shared_token}` },
        withCredentials: true,
      });
      setResUserDisplay(data.result);
      setResUserDisplayLogo(data.result?.logo);
    } catch (error) {
      if (error === "Unauthorized") {
        window.location.replace("/login");
      }
      // }
    }
  };

  const checkpathname = () => {
    switch (window.location.pathname) {
      case "/dashboard-insurance":
        return "รายการขอประวัติการรักษา";
      case "/send-request":
        return "ส่งคำร้องขอประวัติการรักษา";
      case "/execution-status":
        return "สถานะการดำเนินการ";
      case "/confirm-success":
        return "รายการยืนยันประวัติสำเร็จ";
      case "/newpassword-login":
        return "ตั้งค่ารหัสผ่านใหม่";
      case "/manage-user":
        return "จัดการผู้ใช้งาน";
      default:
        return "ส่งคำร้องขอประวัติการรักษา";
    }
  };
  const handleMenuClick = (): any => {
    webapi
      .post(`${APIEndpointWeb.logout}`, {
        withCredentials: true,
      })
      .then(() => {})
      .catch((error) => {
        console.log(error.response);
      });
    history.replace("/login");
  };
  const ratingscore = async (): Promise<any> => {
    const score = {
      score: [
        {
          topic: "ความง่าย ความสะดวก",
          score: `${valRatingscore1}`,
        },
        {
          topic: "ความพร้อมในการใช้งาน",
          score: `${valRatingscore2}`,
        },
        {
          topic: "ความน่าเชื่อถือของระบบ",
          score: `${valRatingscore3}`,
        },
        {
          topic: "การตอบสนองในการใช้งาน",
          score: `${valRatingscore4}`,
        },
      ],
      comment: valRatingComment,
      score_dashboard: [
        {
          topic:
            "การแสดงผลและการออกแบบ เข้าใจง่าย มีข้อมูลครบถ้วนจามที่ต้องการ",
          score: `${valScoreDashboard}`,
        },
      ],
      // score_dashboard: valScoreDashboard,
      comment_dashboard: valCommentDashboard,
    };
    try {
      const { data } = await webapi.post(
        `${APIEndpointWeb.ratingscore}`,
        score,
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      if (error === "Unauthorized") {
        window.location.replace("/login");
      }
      // }
    }
  };
  const confirmratingscore = () => {
    Modal.confirm({
      title: "ยืนยันส่งข้อมูล",
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
      content: " ",
      okText: "ตกลง",
      onOk: (): void => {
        ratingscore();
        window.location.reload();
      },
      cancelText: "ยกเลิก",
      okButtonProps: { style: { background: "#147F8B", borderRadius: "5px" } },
      cancelButtonProps: {
        style: { background: "#B5B5B5", color: "white", borderRadius: "5px" },
      },
    });
  };
  const ticket = async (): Promise<any> => {
    const payload = {
      description: ticketdDescription,
      ticket_image: ticketImage,
    };
    try {
      const { data } = await webapi.post(`${APIEndpointWeb.ticket}`, payload, {
        withCredentials: true,
      });
    } catch (error) {
      if (error === "Unauthorized") {
        window.location.replace("/login");
      }
      // }
    }
  };
  const confirmticket = () => {
    Modal.confirm({
      title: "ยืนยันส่งข้อมูล",
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
      content: " ",
      okText: "ตกลง",
      onOk: (): void => {
        ticket();
        window.location.reload();
      },
      cancelText: "ยกเลิก",
      okButtonProps: { style: { background: "#147F8B", borderRadius: "5px" } },
      cancelButtonProps: {
        style: { background: "#B5B5B5", color: "white", borderRadius: "5px" },
      },
    });
  };
  const showConfirm = (): any => {
    Modal.confirm({
      title: "คุณต้องการออกจากระบบใช่หรือไม่",
      // content: 'ลงชื่อออก',
      okText: "ตกลง",
      cancelText: "ยกเลิก",
      okButtonProps: {
        type: "primary",
      },
      cancelButtonProps: {
        type: "default",
      },
      onOk() {
        setTimeout(() => {
          handleMenuClick();
        }, 1000);
      },
      onCancel() {
        // console.log('can');
      },
    });
  };

  const props1: UploadProps = {
    name: "file",
    multiple: true,
    action: "",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        setTicketImage(info.fileList);
        // console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  // const Menutest =
  const Menutest = (): JSX.Element => {
    return (
      <Row className="test222">
        <Row
          className="pb-2 test333"
          style={{
            width: "34vh",
          }}
        >
          <Col
            className="pl-2 pr-2"
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
          >
            <Card
              style={{
                backgroundColor: "#26334A",
                borderRadius: "20px 20px 0px 0px",
              }}
            >
              <Row style={{ textAlign: "center" }}>
                <Col xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                  <Avatar size="large" icon={<UserOutlined />} />
                </Col>
                <Col
                  xs={18}
                  sm={18}
                  md={18}
                  lg={18}
                  xl={18}
                  xxl={18}
                  className="mt-2"
                >
                  <Text style={{ color: "#ffffff", fontSize: "16px" }}>
                    {resUserDisplay?.name}
                  </Text>
                </Col>
              </Row>
            </Card>
            <Row>
              <Col
                className="pl-2 pr-2"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
                style={{
                  backgroundColor: "#26334A",
                  borderRadius: "0px 0px 20px 20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Text
                  className="mt-2 mb-2"
                  style={{ color: "#ffffff", fontSize: "14px" }}
                >
                  {resUserDisplay?.insurer}
                </Text>
              </Col>
            </Row>

            <Row className="pt-2 pb-2" style={{ backgroundColor: "#B6D3D6" }}>
              <Menu mode="inline" style={{ backgroundColor: "#B6D3D6 " }}>
                <Menu.Item
                  key="1"
                  onClick={showModalRate}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <StarOutlined
                    style={{
                      fontSize: "20px",
                      color: "#26334A",
                    }}
                  />
                  <Text>แบบประเมินความพึงพอใจ</Text>
                </Menu.Item>
                <Menu.Item
                  key="2"
                  onClick={showModalWarning}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <WarningOutlined
                    style={{
                      fontSize: "20px",
                      color: "#26334A",
                    }}
                  />
                  <Text>แจ้งปัญหาและข้อเสนอแนะ</Text>
                </Menu.Item>
                <Menu.Item
                  key="3"
                  onClick={showModal3}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <LockOutlined
                    style={{
                      fontSize: "20px",
                      color: "#26334A",
                    }}
                  />
                  <Text>เปลี่ยนรหัสผ่าน</Text>
                </Menu.Item>
                <Menu.Item
                  key="4"
                  onClick={showModal1}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <FileProtectOutlined
                    style={{
                      fontSize: "20px",
                      color: "#26334A",
                    }}
                  />
                  <Text>ข้อกำหนดการใช้งาน</Text>
                </Menu.Item>
                <Menu.Item
                  key="5"
                  onClick={showModal2}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <SafetyCertificateOutlined
                    style={{
                      fontSize: "20px",
                      color: "#26334A",
                    }}
                  />
                  <Text>นโยบายคุ้มครองข้อมูลส่วนบุคคล</Text>
                </Menu.Item>
                <Menu.Item
                  key="6"
                  onClick={showConfirm}
                  style={{ border: "0px solid #B6D3D6", borderRadius: "10px" }}
                >
                  <LogoutOutlined
                    style={{
                      fontSize: "20px",
                      color: "#26334A",
                    }}
                  />
                  <Text> ออกจากระบบ </Text>
                </Menu.Item>
              </Menu>
            </Row>
            <Modal
              title="ข้อกำหนดการใช้งาน FMR"
              // width='540px'
              // className="modal-left"
              visible={isModalTermsAndConditions}
              onOk={handleOk1}
              onCancel={handleCancel1}
              footer={
                <Button type="primary" size="middle" onClick={handleCancel1}>
                  ปิด
                </Button>
              }
            >
              <ModalTermsOfUse />
            </Modal>
            <Modal
              title="นโยบายคุ้มครองข้อมูลส่วนบุคคล"
              visible={isModalOpenPolicy}
              onOk={handleOk2}
              onCancel={handleCancel2}
              footer={
                <Button type="primary" size="middle" onClick={handleCancel2}>
                  ปิด
                </Button>
              }
            >
              <ModalPolicy />
            </Modal>
            <Modal
              className="modal-left"
              width="540px"
              title="แบบประเมินความพึงพอใจ"
              visible={showModalshowModalRate}
              onCancel={handleCancelRate}
              footer={
                <div>
                  <Row justify="center" className="pt-2 pb-2" gutter={[16, 8]}>
                    <>
                      <Button
                        type="ghost"
                        style={{
                          borderRadius: "10px",
                          height: "5vh",
                          width: "30%",
                        }}
                        onClick={handleCancelRate}
                      >
                        ยกเลิก
                      </Button>
                      <Button
                        onClick={confirmratingscore}
                        disabled={
                          valRatingscore1 === "" ||
                          valRatingscore2 === "" ||
                          valRatingscore3 === "" ||
                          valRatingscore4 === "" ||
                          valRatingComment === "" ||
                          valCommentDashboard === "" ||
                          valScoreDashboard === ""
                        }
                        type="primary"
                        style={{
                          borderRadius: "10px",
                          height: "5vh",
                          width: "30%",
                        }}
                      >
                        ส่ง
                      </Button>
                    </>
                  </Row>
                </div>
              }
            >
              <Col
                className="mr-4 ml-4 mt-2 mb-2"
                style={{ overflowY: "scroll", height: 380 }}
              >
                <Row>
                  <Text style={{ fontSize: "14px", fontWeight: "bold" }}>
                    1. ความพึงพอใจของระบบ
                  </Text>
                  <Divider style={{ marginTop: "15px", marginBottom: "3px" }} />
                </Row>
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text style={{ wordBreak: "break-all", width: "100%" }}>
                      {" "}
                      1.1 ความง่ายความสะดวก{" "}
                    </Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValRatingscore1}
                        value={valRatingscore1}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "3px", marginBottom: "3px" }} />
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text> 1.2 ความพร้อมในการใช้งาน </Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValRatingscore2}
                        value={valRatingscore2}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "3px", marginBottom: "3px" }} />
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text> 1.3 ความน่าเชื่อถือของระบบ</Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValRatingscore3}
                        value={valRatingscore3}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "3px", marginBottom: "3px" }} />
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text> 1.4 การตอบสนองในการใช้งาน </Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValRatingscore4}
                        value={valRatingscore4}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "3px", marginBottom: "3px" }} />
                {/* <Row>
                <Text style={{ fontSize: "14px", fontWeight: "bold", marginTop: "15px" }}>
                  ข้อเสนอแนะ
                </Text>
              </Row> */}
                <Row className="mt-3">
                  <Input.TextArea
                    value={valRatingComment}
                    onChange={(e) => {
                      setValRatingComment(e.target.value);
                    }}
                    placeholder="ข้อเสนอแนะความพึงพอใจของระบบ"
                    style={{ width: "100%", borderRadius: "8px" }}
                    rows={3}
                  />
                </Row>
                <Row>
                  <Text
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      marginTop: "15px",
                    }}
                  >
                    2. ความพึงพอใจของ Dashboard
                  </Text>
                  <Divider style={{ marginTop: "15px", marginBottom: "3px" }} />
                </Row>
                <Row>
                  <Col
                    xs={14}
                    sm={14}
                    md={14}
                    lg={14}
                    xl={14}
                    xxl={14}
                    className="mt-1"
                  >
                    <Text>
                      {" "}
                      2.1 การแสดงผลและการออกแบบ เข้าใจง่าย
                      มีข้อมูลครบถ้วนจามที่ต้องการ{" "}
                    </Text>
                  </Col>
                  <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
                    <span>
                      <Rate
                        tooltips={desc}
                        onChange={setValScoreDashboard}
                        value={valScoreDashboard}
                      />
                    </span>
                  </Col>
                </Row>
                <Divider style={{ marginTop: "15px", marginBottom: "3px" }} />
                <Row className="mt-3">
                  <Input.TextArea
                    value={valCommentDashboard}
                    onChange={(e) => {
                      setValCommentDashboard(e.target.value);
                    }}
                    placeholder="ข้อเสนอแนะความพึงพอใจของ Dashboard
                  "
                    style={{ width: "100%", borderRadius: "8px" }}
                    rows={3}
                  />
                </Row>

                {/* <Row>
                <Text style={{ fontSize: "14px", fontWeight: "bold" }}>
                  ข้อเสนอแนะ
                </Text>
              </Row> */}
              </Col>
            </Modal>

            <Modal
              className="modal-left"
              width="540px"
              title="แจ้งปัญหาและข้อเสนอแนะ"
              visible={showModalshowModalWarning}
              onCancel={handleCancelWarning}
              footer={
                <div>
                  <Row justify="center" className="pt-2 pb-2" gutter={[16, 8]}>
                    <>
                      <Button
                        type="ghost"
                        style={{
                          borderRadius: "10px",
                          height: "5vh",
                          width: "30%",
                        }}
                        onClick={handleCancelWarning}
                      >
                        ยกเลิก
                      </Button>
                      <Button
                        onClick={confirmticket}
                        disabled={
                          ticketdDescription === "" || ticketImage.length < 1
                        }
                        type="primary"
                        style={{
                          borderRadius: "10px",
                          height: "5vh",
                          width: "30%",
                        }}
                      >
                        ส่ง
                      </Button>
                    </>
                  </Row>
                </div>
              }
            >
              <div
                style={{
                  maxHeight: 450,
                  overflowX: "hidden",
                  padding: "5px",
                }}
              >
                <Row>
                  <Text style={{ fontWeight: "bold" }}>เพิ่มข้อความ :</Text>
                </Row>
                <Input.TextArea
                  value={ticketdDescription}
                  onChange={(e) => {
                    setTicketdDescription(e.target.value);
                  }}
                  className="mt-2"
                  placeholder="ระบุปัญหาที่ต้องการแจ้ง..."
                  style={{ width: "100%", borderRadius: "8px" }}
                  rows={5}
                />
                <Row className="mt-4 ml-2">
                  <Text style={{ fontWeight: "bold" }}>เพิ่มรูปภาพ :</Text>
                </Row>
                <Dragger
                  {...props1}
                  className="mt-2"
                  multiple={true}
                  maxCount={5}
                  accept="image/*"
                  action={""}
                  beforeUpload={() => false}
                  // fileList={nameFilePDFIDCard}
                  listType="picture"
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">เพิ่มรูปภาพของคุณ</p>
                </Dragger>
              </div>
            </Modal>
            <Modal
              width="540px"
              // className="modal-left"
              visible={showModalResetPassword}
              onOk={handleOk3}
              onCancel={handleCancel3}
              footer={null}
            >
              <NewPasswordLogin />
            </Modal>
          </Col>
        </Row>
      </Row>
    );
  };

  return (
    <Layout>
      {goToPath ? <Redirect to={goToPath} /> : null}
      {WindowResize > 991 && (
        <>
          <Layout style={{ minHeight: "100vh" }}>
            <Sider
              width={250}
              trigger={null}
              collapsible
              collapsed={collapsed}
              style={{
                backgroundColor: "#4EA5B2",
                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
              }}
            >
              <div
                className={collapsed === false ? "ml-4" : "box-center"}
                style={{
                  paddingTop: 33,
                  paddingBottom: 33,
                  height: "84px",
                  paddingLeft: collapsed === false ? 12 : "",
                }}
              >
                <Image
                  preview={false}
                  src={collapsed === true ? icon_logo : logono1}
                  width={collapsed === false ? "80%" : "50%"}
                />
              </div>
              <Menu
                mode="inline"
                defaultSelectedKeys={defaultSelectedKeys}
                className="mt-5"
                style={{ backgroundColor: "#4fa5b2" }}
              >
                <Menu.Item
                  onClick={() => {
                    history.push("/dashboard-insurance");
                    setdefaultSelectedKeys(["1"]);
                  }}
                  key="1"
                  style={{ border: "0px solid #B6D3D6", height: "50px" }}
                >
                  <AppstoreOutlined style={{ fontSize: "20px" }} />
                  <span style={{ fontSize: "16px" }}>
                    รายการขอประวัติการรักษา
                  </span>
                </Menu.Item>
                <Menu.Item
                  key="2"
                  onClick={() => {
                    history.push("/send-request");
                    setdefaultSelectedKeys(["2"]);
                  }}
                  style={{ border: "0px solid #B6D3D6", height: "50px" }}
                >
                  <FormOutlined style={{ fontSize: "20px" }} />
                  <span style={{ fontSize: "16px" }}>ส่งคำร้องขอประวัติ</span>
                </Menu.Item>
                <Menu.Item
                  key="3"
                  onClick={() => {
                    history.push("/execution-status");
                  }}
                  style={{ border: "0px solid #B6D3D6", height: "50px" }}
                >
                  <FieldTimeOutlined style={{ fontSize: "22px" }} />
                  <span style={{ fontSize: "16px" }}>สถานะการดำเนินการ</span>
                </Menu.Item>
                <Menu.Item
                  key="4"
                  onClick={() => {
                    history.push("/confirm-success");
                  }}
                  style={{ border: "0px solid #B6D3D6", height: "50px" }}
                >
                  <FileDoneOutlined style={{ fontSize: "20px" }} />
                  <span style={{ fontSize: "16px" }}>
                    รายการยืนยันประวัติสำเร็จ
                  </span>
                </Menu.Item>
              </Menu>
              <div
                className={collapsed === false ? "" : "box-center"}
                style={{
                  paddingTop: 33,
                  paddingBottom: 33,
                  height: "84px",
                  paddingLeft: collapsed === false ? 12 : "",
                }}
              >
                {collapsed ? (
                  <>
                    <Button
                      size="middle"
                      style={{
                        borderRadius: "10px",
                        backgroundColor: "#005A67",
                        border: "none",
                        color: "#ffffff",
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        marginLeft: "15px",
                        marginBottom: "80px",
                      }}
                    >
                      <a
                        target="_blank"
                        href="https://docs.google.com/document/d/12GXgX-0szTCKbhOnMbq39y4rzqb6DAG8Fd9gL3kpcmE/edit"
                      >
                        <FileTextOutlined style={{ color: "#ffffff" }} />
                      </a>
                    </Button>
                    <Button
                      size="middle"
                      style={{
                        borderRadius: "10px",
                        backgroundColor: "#005A67",
                        border: "none",
                        color: "#ffffff",
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        marginLeft: "15px",
                        marginBottom: "30px",
                      }}
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      <SyncOutlined style={{ color: "#ffffff" }} />
                    </Button>
                  </>
                ) : (
                  <>
                    <a
                      style={{
                        color: "#ffffff",
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        marginLeft: "65px",
                        marginBottom: "80px",
                      }}
                      target="_blank"
                      href="https://docs.google.com/document/d/12GXgX-0szTCKbhOnMbq39y4rzqb6DAG8Fd9gL3kpcmE/edit"
                    >
                      <FileTextOutlined style={{ color: "#ffffff" }} />
                      &nbsp;คู่มือการใช้งาน
                    </a>
                    <Button
                      size="middle"
                      style={{
                        borderRadius: "10px",
                        backgroundColor: "#005A67",
                        border: "none",
                        color: "#ffffff",
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        marginLeft: "65px",
                        marginBottom: "30px",
                      }}
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      <SyncOutlined style={{ color: "#ffffff" }} />
                      &nbsp;Refresh
                    </Button>
                  </>
                )}
              </div>
            </Sider>
            <Layout>
              <Header
                style={{
                  boxShadow: "2px 2px 15px rgba(0, 0, 0, 0.25)",
                  // position: "fixed",
                  zIndex: 1000,
                  top: 0,
                  left: 280,
                  right: 0,
                  height: "80px",
                }}
              >
                <Row justify="space-between">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "80px",
                    }}
                  >
                    <Button
                      type="text"
                      icon={
                        collapsed ? (
                          <MenuUnfoldOutlined />
                        ) : (
                          <MenuFoldOutlined />
                        )
                      }
                      onClick={() => setCollapsed(!collapsed)}
                      style={{
                        fontSize: "16px",
                        width: 64,
                        height: 64,
                      }}
                    />
                    <Text
                      style={{
                        color: " #147F8B",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      {" "}
                      {checkpathname()}
                    </Text>
                  </div>
                  <div
                    className="mr-4"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "80px",
                    }}
                  >
                    <Space size={40}>
                      <Space
                        direction="vertical"
                        className="space-gap"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Text
                          style={{
                            color: "#147F8B",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {resUserDisplay?.insurer}
                        </Text>

                        <Text
                          className="font-description"
                          style={{ color: "#147F8B", fontSize: "14px" }}
                        >
                          {resUserDisplay?.name}
                        </Text>
                      </Space>
                      <Text style={{ color: " #147F8B", fontSize: "28px" }}>
                        {" "}
                        |
                      </Text>
                      <>
                        <Button
                          size="large"
                          style={{ cursor: "pointer" }}
                          shape="circle"
                          icon={<UserOutlined />}
                          onClick={showDrawerRight}
                        />
                        <Drawer
                          width={265}
                          placement="right"
                          onClose={onCloseRight}
                          visible={openRight}
                        >
                          {Menutest()}
                          {/* <Menutest /> */}
                        </Drawer>
                      </>
                    </Space>
                  </div>
                </Row>
              </Header>
              <Content>
                {window.location.pathname === "/execution-status" ? (
                  <HomeWebStatusAgent resUserDisplayLogo={resUserDisplayLogo} />
                ) : (
                  children
                )}
              </Content>
            </Layout>
          </Layout>
        </>
      )}
      {WindowResize <= 991 && (
        <Layout>
          <Drawer
            onClose={onClose}
            visible={open}
            placement="left"
            key="left"
            closable={false}
            width={330}
          >
            <Row
              style={{ display: "flex", justifyContent: "center" }}
              className="mt-5"
            >
              <Image preview={false} src={logofmrgg} width="50%" />
            </Row>
            <Row
              className="p-4 m-2 mt-4"
              style={{ backgroundColor: "#AFD8D9", borderRadius: "20px" }}
            >
              <Col>
                <Avatar
                  style={{ cursor: "pointer", backgroundColor: "#095a66" }}
                  size="large"
                  icon={<UserOutlined />}
                />
              </Col>
              <Col className="ml-3">
                <Space
                  direction="vertical"
                  className="space-gap"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      color: "#147F8B",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    {resUserDisplay?.insurer}
                  </Text>
                  <Text
                    className="font-description"
                    style={{ color: "#147F8B", fontSize: "12px" }}
                  >
                    {resUserDisplay?.name}
                  </Text>
                </Space>
              </Col>
              {/* <Col
                style={{ display: "flex", alignItems: "center" }}
                className="ml-4"
              >
                <CaretDownOutlined />
              </Col> */}
            </Row>
            {/* <Dropdown
              overlay={menu}
              overlayStyle={{ paddingTop: "25px" }}
              placement="bottomRight"
            >
             
            </Dropdown> */}
            <Menu
              mode="inline"
              defaultSelectedKeys={defaultSelectedKeys}
              className="mt-4"
              // style={{ backgroundColor: "#4fa5b2" }}
            >
              <Menu.Item
                onClick={() => {
                  history.push("/dashboard-insurance");
                  setdefaultSelectedKeys(["1"]);
                }}
                key="1"
                style={{ border: "0px solid #B6D3D6", height: "50px" }}
              >
                <AppstoreOutlined style={{ fontSize: "20px" }} />
                <span style={{ fontSize: "16px" }}>
                  รายการขอประวัติการรักษา
                </span>
              </Menu.Item>
              <Menu.Item
                key="2"
                onClick={() => {
                  history.push("/send-request");
                  setdefaultSelectedKeys(["2"]);
                }}
                style={{ border: "0px solid #B6D3D6", height: "50px" }}
              >
                <FormOutlined style={{ fontSize: "20px" }} />
                <span style={{ fontSize: "16px" }}>ส่งคำร้องขอประวัติ</span>
              </Menu.Item>
              <Menu.Item
                key="3"
                onClick={() => {
                  history.push("/execution-status");
                }}
                style={{ border: "0px solid #B6D3D6", height: "50px" }}
              >
                <FieldTimeOutlined style={{ fontSize: "22px" }} />
                <span style={{ fontSize: "16px" }}>สถานะการดำเนินการ</span>
              </Menu.Item>
              <Menu.Item
                key="4"
                onClick={() => {
                  history.push("/confirm-success");
                }}
                style={{ border: "0px solid #B6D3D6", height: "50px" }}
              >
                <FileDoneOutlined style={{ fontSize: "20px" }} />
                <span style={{ fontSize: "16px" }}>
                  รายการยืนยันประวัติสำเร็จ
                </span>
              </Menu.Item>
            </Menu>

            <a
              style={{
                color: "#005A67",
                position: "fixed",
                bottom: 0,
                left: 0,
                marginLeft: "110px",
                marginBottom: "80px",
              }}
              target="_blank"
              href="https://docs.google.com/document/d/12GXgX-0szTCKbhOnMbq39y4rzqb6DAG8Fd9gL3kpcmE/edit"
            >
              <FileTextOutlined style={{ color: "#ffffff" }} />
              &nbsp;คู่มือการใช้งาน
            </a>
            <Button
              size="middle"
              style={{
                borderRadius: "10px",
                backgroundColor: "#005A67",
                border: "none",
                color: "#ffffff",
                position: "fixed",
                bottom: 0,
                left: 0,
                marginLeft: "120px",
                marginBottom: "30px",
              }}
              onClick={() => {
                window.location.reload();
              }}
            >
              <SyncOutlined style={{ color: "#ffffff" }} />
              &nbsp;Refresh
            </Button>
          </Drawer>
          <Header
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1000,
              width: "100%",
              boxShadow: " 0px 1px 20px 1px rgba(128, 128, 128, 0.65",
            }}
          >
            <Row>
              <Col
                xs={17}
                md={17}
                lg={17}
                xl={17}
                xxl={17}
                className=" pl-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Image preview={false} src={icon_logo} width={50} />
                <Text className="ml-3 font-h "> {checkpathname()}</Text>
              </Col>
              <Col xs={7} md={7} lg={7} xl={7} xxl={7}>
                <div className="layoutHeader">
                  <Button
                    type="text"
                    onClick={showDrawer}
                    className="btn-drwer"
                  >
                    <MenuOutlined />
                  </Button>
                  {/* <>
                    <Avatar size={64} icon={<Button
                      style={{ cursor: "pointer" }}
                      size="large"
                      icon={<UserOutlined />}
                      onClick={showDrawerTop}
                    />} />
                    <Drawer title="Basic Drawer" placement="top" onClose={onCloseTop} visible={openTop}>
                      <p>Some contents...</p>
                      <p>Some contents...</p>
                      <p>Some contents...</p>
                    </Drawer>
                  </> */}
                  <>
                    <Button
                      size="large"
                      style={{ cursor: "pointer" }}
                      shape="circle"
                      icon={<UserOutlined />}
                      onClick={showDrawerTop}
                    />
                    {openTop === false ? (
                      <Drawer
                        placement="top"
                        className="test112"
                        onClose={onCloseTop}
                        visible={openTop}
                      >
                        {Menutest()}
                      </Drawer>
                    ) : (
                      <Drawer
                        placement="top"
                        className="test111"
                        onClose={onCloseTop}
                        visible={openTop}
                      >
                        {Menutest()}
                      </Drawer>
                    )}
                  </>
                </div>
              </Col>
            </Row>
          </Header>
          <Content style={{ minHeight: "100vh" }}>
            {window.location.pathname === "/execution-status" ? (
              <HomeStatusAgent resUserDisplayLogo={resUserDisplayLogo} />
            ) : (
              children
            )}
          </Content>
        </Layout>
      )}
    </Layout>
  );
};
export default InsuranceLayout;
